import styled from "styled-components";

export const NoChatContainer = styled.div`
  width: 100%;
  height: 84vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  
  @media (max-width: 768px) {
   display: none;
  }
  img {
    width: 70px;
  }
  p {
    color: black;
    font-size: 20px;
    font-weight: 600;
  }
  span {
    font-size: 15px;
    width: 50%;
    text-align: center;
    color: rgba(109, 109, 109, 0.946);
  }
`;
